import LZString from 'lz-string';
import { getAdjustedCompanyListDataForInnerSearch } from '../views/companies/list/CompaniesHelper';
import { getDefaultThemeSetting } from './ThemeHelper';

export function setThemeSettingCache(themeSetting) {
  localStorage.setItem('themeSetting', JSON.stringify(themeSetting));
}

export function getThemeSettingCache() {
  let themeSettingJson = localStorage.getItem('themeSetting');

  if (themeSettingJson == null || themeSettingJson === '') {
    let defaultThemeSetting = getDefaultThemeSetting();
    setThemeSettingCache(defaultThemeSetting);
    return defaultThemeSetting;
  }

  return JSON.parse(themeSettingJson);
}

export function setCompanyListCache(companies) {
  if (companies.length > 10000) return;

  localStorage.setItem(
    'companies',
    LZString.compress(JSON.stringify(companies))
  );
}

export function setCentralizedCompanyListCache(companies) {
  if (companies.length > 10000) return;

  localStorage.setItem(
    'centralizedCompanies',
    LZString.compress(JSON.stringify(companies))
  );
}

export function setLightWeightCentralizedCompanyListCache(companies) {
  if (companies.length > 10000) return;

  localStorage.setItem(
    'lightWeightCentralizedCompanies',
    LZString.compress(JSON.stringify(companies))
  );
}

export function getCompanyListCache() {
  let companiesData = localStorage.getItem('companies');

  let companiesCache = JSON.parse(
    companiesData != null ? LZString.decompress(companiesData) : '[]'
  );

  return getAdjustedCompanyListDataForInnerSearch(companiesCache);
}

export function getCentralizedCompanyListCache() {
  let companiesData = localStorage.getItem('centralizedCompanies');

  let companiesCache = JSON.parse(
    companiesData != null ? LZString.decompress(companiesData) : '[]'
  );

  return getAdjustedCompanyListDataForInnerSearch(companiesCache);
}

export function getLightWeightCentralizedCompanyListCache() {
  let companiesData = localStorage.getItem('lightWeightCentralizedCompanies');

  let companiesCache = JSON.parse(
    companiesData != null ? LZString.decompress(companiesData) : '[]'
  );

  return getAdjustedCompanyListDataForInnerSearch(companiesCache);
}

export function setCompanySearchFilterCache(filter) {
  localStorage.setItem('companySearchFilter', JSON.stringify(filter));
}

export function setLightWeightCompanySearchFilterCache(filter) {
  localStorage.setItem(
    'lightWeightCompanySearchFilter',
    JSON.stringify(filter)
  );
}

export function setPartnerStackCompanyListCache(companies) {
  if (companies.length > 10000) return;

  localStorage.setItem(
    'partnerStackCompanies',
    LZString.compress(JSON.stringify(companies))
  );
}

export function getPartnerStackCompanyListCache() {
  let companiesData = localStorage.getItem('partnerStackCompanies');

  let companiesCache = JSON.parse(
    companiesData != null ? LZString.decompress(companiesData) : '[]'
  );

  return companiesCache;
}

export function setPartnerStackCompanySearchFilterCache(filter) {
  localStorage.setItem(
    'partnerStackCompanySearchFilter',
    JSON.stringify(filter)
  );
}

export function getPartnerStackCompanySearchFilterCache() {
  let filterData = localStorage.getItem('partnerStackCompanySearchFilter');

  return JSON.parse(filterData != null ? filterData : null);
}

export function getCompanySearchFilterCache() {
  let filterData = localStorage.getItem('companySearchFilter');

  return JSON.parse(filterData != null ? filterData : null);
}

export function getLightWeightCompanySearchFilterCache() {
  let filterData = localStorage.getItem('lightWeightCompanySearchFilter');

  return JSON.parse(filterData != null ? filterData : null);
}

export function getCompanyFilterExtraOptionCache() {
  let option = localStorage.getItem('companyFilterExtraOption');

  return option != null
    ? JSON.parse(option)
    : {
        isExcludeUserProfileCount: false,
        isOrConditionFilter: false,
        isAllowCacheFlowHubData: true,
        isDeduplicationRequired: true,
        isAllowCacheIntelligentHubData: true
      };
}

export function setCompanyFilterExtraOptionCache(option) {
  localStorage.setItem('companyFilterExtraOption', JSON.stringify(option));
}

export function getAnalyticOptionCache() {
  let option = localStorage.getItem('analyticOptionCache');

  return option != null ? JSON.parse(option) : { isExcludeMarkup: false };
}

export function setAnalyticOptionCache(option) {
  localStorage.setItem('analyticOptionCache', JSON.stringify(option));
}

export function getPartnerStackCompanyFilterExtraOptionCache() {
  let option = localStorage.getItem('partnerStackCompanyFilterExtraOption');

  return option != null
    ? JSON.parse(option)
    : {
        IsAllowTransactionCache: true
      };
}

export function setPartnerStackCompanyFilterExtraOptionCache(option) {
  localStorage.setItem(
    'partnerStackCompanyFilterExtraOption',
    JSON.stringify(option)
  );
}

export function removeAllCache() {
  // localStorage.removeItem('themeSetting')
  localStorage.removeItem('companies');
  localStorage.removeItem('companySearchFilter');
}

